import "./Layout.css";
import { Outlet } from "react-router-dom";
import Layout, { Content } from "antd/es/layout/layout";
import { Space } from "antd";
import Sider from "antd/es/layout/Sider";
import Sidebar from "../../../components/LayoutComponent/SideBar/Sidebar";
import TopBar from "../../../components/LayoutComponent/TopBar/topBar";

const LandingPagesLayout = () => {
  return (
    <>
     <Layout>
       {/* This div acts as the main page background container */}
       <div className="bg-white dark:bg-stone-900" style={{ minHeight: "100vh" }}>
        <Content>
           <Outlet />
         </Content>
       </div>
     </Layout>
    </>
  );
};

export default LandingPagesLayout;
